"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _dom = require("../utils/dom");
const useSetPageTitle = brandName => {
  (0, _react.useEffect)(() => {
    (0, _dom.setPageTitle)(brandName);
  }, [brandName]);
};
var _default = exports.default = useSetPageTitle;